import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../firebase'; // adjust path if needed
import { useLanguage } from '../../i18n';
import styles from './Login.module.css';

export default function Login() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/'); // redirect to home
    } catch (err) {
      setError(err.message || 'Sign in failed');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setError('');
    setLoading(true);

    try {
      await signInWithPopup(auth, googleProvider);
      navigate('/'); // redirect to home
    } catch (err) {
      setError(err.message || 'Google sign in failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.logoWrapper}>
            <Icon icon="fa-solid:shield-alt" className={styles.logo} />
          <h1 className={styles.title}>{t('loginTitle')}</h1>
          </div>

          <p className={styles.subtitle}>
          {t('loginSubtitle')}
          </p>

          {error && (
            <div className={styles.error}>
              <Icon icon="lucide:alert-triangle" />
              {error}
            </div>
          )}

          <form onSubmit={handleEmailSignIn} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="email">{t('emailLabel')}</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="sarah.chen@securenet.org"
                required
                disabled={loading}
              />
            </div>

            <div className={styles.field}>
              <label htmlFor="password">{t('passwordLabel')}</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className={styles.btnPrimary} disabled={loading}>
              {loading ? t('signingIn') : t('loginTitle')}
            </button>
          </form>

          <div className={styles.divider}>
            <span>{t('orText')}</span>
          </div>

          <button 
            className={styles.socialBtn} 
            onClick={handleGoogleSignIn}
            disabled={loading}
          >
            <Icon icon="logos:google-icon" className={styles.socialIcon} />
            {t('continueWithGoogle')}
          </button>

          <div className={styles.footerLinks}>
            <Link to="/forgot-password" className={styles.link}>
              {t('forgotPassword')}
            </Link>
            <p>
              {t('noAccountSignUp')}{' '}
              <Link to="/register" className={styles.link}>
                {t('registerTitle')}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
// import { Link } from 'react-router-dom';
// import { Icon } from '@iconify/react';
// import { useState } from 'react';
// import styles from './Login.module.css';

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   setError('');
//   //   setLoading(true);

//   //   // Dummy validation
//   //   setTimeout(() => {
//   //     if (!email || !password) {
//   //       setError('Please fill in all fields');
//   //     } else {
//   //       // Simulate success → redirect
//   //       window.location.href = '/'; // or use useNavigate
//   //     }
//   //     setLoading(false);
//   //   }, 1000);
//   // };
//   // src/pages/Login/Login.jsx (update handleSubmit)
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setError('');
//   setLoading(true);

//   try {
//     await signInWithEmailAndPassword(auth, email, password);
//     navigate('/'); // redirect to home on success
//   } catch (err) {
//     setError(err.message || 'Sign in failed');
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <main className={styles.main}>
//       <div className={styles.container}>
//         <div className={styles.card}>
//           <div className={styles.logoWrapper}>
//             <Icon icon="fa-solid:shield-alt" className={styles.logo} />
//             <h1 className={styles.title}>Sign In</h1>
//           </div>

//           <p className={styles.subtitle}>
//             Access your saved resources, submit new ones, and manage your account.
//           </p>

//           {error && (
//             <div className={styles.error}>
//               <Icon icon="lucide:alert-triangle" />
//               {error}
//             </div>
//           )}

//           <form onSubmit={handleSubmit} className={styles.form}>
//             <div className={styles.field}>
//               <label htmlFor="email">Email</label>
//               <input
//                 id="email"
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="sarah.chen@securenet.org"
//                 required
//               />
//             </div>

//             <div className={styles.field}>
//               <label htmlFor="password">Password</label>
//               <input
//                 id="password"
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="••••••••"
//                 required
//               />
//             </div>

//             <button type="submit" className={styles.btnPrimary} disabled={loading}>
//               {loading ? 'Signing in...' : 'Sign In'}
//             </button>
//           </form>

//           <div className={styles.divider}>
//             <span>or</span>
//           </div>

//           <button className={styles.socialBtn}>
//             <Icon icon="logos:google-icon" className={styles.socialIcon} />
//             Continue with Google
//           </button>

//           <div className={styles.footerLinks}>
//             <Link to="/forgot-password" className={styles.link}>
//               Forgot password?
//             </Link>
//             <p>
//               Don't have an account?{' '}
//               <Link to="/register" className={styles.link}>
//                 Sign up
//               </Link>
//             </p>
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }